import classNames from 'classnames';
import { forwardRef, PropsWithChildren } from 'react';

export interface CardContentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  className?: string;
  variant?: 'default' | 'fill';
}

/**
 * Content component for cards
 */
const CardContent = forwardRef<HTMLDivElement, PropsWithChildren<CardContentProps>>((props, ref) => {
  const { children, className, variant = 'default', ...otherProps } = props;

  return (
    <div
      {...otherProps}
      ref={ref}
      className={classNames(
        'flex-1 flex flex-col',
        variant === 'default' && 'px-4 pb-4',
        className
      )}
    >
      {children}
    </div>
  );
});

CardContent.displayName = 'CardContent';

export { CardContent };

export default CardContent;
